(() => {
const feUi = JSON.parse(document.getElementById('fe-landing-ui-strings')?.textContent || '{}');
// One lazy video, no global navigation/cart hooks. Custom element handles editor lifecycle.
if (!customElements.get('fe-v8-hero')) {
  customElements.define('fe-v8-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 767px)');
      this.userPaused = false;
      this.visible = false;
      this.ready = false;
      this.failed = false;
      this.update = this.update.bind(this);
      this.video.addEventListener('playing', () => {this.setAttribute('data-playing','');this.button.textContent=feUi.pause;this.button.setAttribute('aria-label',feUi.pause);},opts);
      this.video.addEventListener('pause', () => {this.button.textContent=feUi.play;this.button.setAttribute('aria-label',feUi.play);},opts);
      this.video.addEventListener('error', () => {this.failed=true;this.removeAttribute('data-playing');this.button.hidden=true;},opts);
      this.button.addEventListener('click', () => {this.userPaused=!this.userPaused;this.update();},opts);
      this.reduced.addEventListener('change',this.update,opts);
      this.mobile.addEventListener('change',this.update,opts);
      document.addEventListener('visibilitychange',this.update,opts);
      this.poster=this.querySelector('[data-fe-poster] img');
      const ready=()=>{this.ready=true;this.update();};
      if (!this.poster || this.poster.complete) ready();
      else {this.poster.addEventListener('load',ready,opts);this.poster.addEventListener('error',ready,opts);}
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();},{threshold:.1});
      this.observer.observe(this);
    }
    update() {
      if (!this.video || !this.ready || this.failed) return;
      const constrained=this.reduced.matches || navigator.connection?.saveData;
      // A desktop-only upload never downloads to mobile; the mobile poster is its fallback.
      const url=this.mobile.matches ? this.video.dataset.mobile : this.video.dataset.desktop;
      if (constrained || !url) {this.video.pause();this.removeAttribute('data-playing');this.button.hidden=true;return;}
      if(this.video.getAttribute('src')!==url) this.removeAttribute('data-playing');
      if (!this.visible || document.hidden || this.userPaused) {this.video.pause();return;}
      if(this.video.getAttribute('src')!==url) {this.removeAttribute('data-playing');this.video.src=url;this.video.load();}
      this.button.hidden=false;
      this.video.muted=true;
      this.video.play().catch(()=>{if(!this.visible||document.hidden||this.reduced.matches)return;this.userPaused=true;this.removeAttribute('data-playing');this.button.textContent=feUi.play;this.button.setAttribute('aria-label',feUi.play);});
    }
    disconnectedCallback() {this.video?.pause();this.events?.abort();this.observer?.disconnect();}
  });
}

})();
